// Dependency-free comms enums. Keeping these here (rather than in a schema/model module like
// `thread.ts` or `scheduling-schemas.ts`) lets any module import them without pulling in those
// modules. `thread.ts` imports `scheduleNewThreadSchema` from `scheduling-schemas.ts`, so
// importing an enum from `thread.ts` into `scheduling-schemas.ts` would create a
// `thread.ts <-> scheduling-schemas.ts` cycle that breaks module evaluation order
// (Zod schemas referenced before initialization).
export enum ClosedReason {
  APPOINTMENT_BOOKED_BY_CLINIC = "appointment_booked_by_clinic",
  APPOINTMENT_BOOKED_BY_VALERIE = "appointment_booked_by_valerie",
  APPOINTMENT_BOOKED = "appointment_booked",
  RESCHEDULED = "rescheduled",
  NO_RESPONSE_FROM_PATIENT = "no_response_from_patient",
  PATIENT_INTAKE = "patient_intake",
  PATIENT_OPTED_OUT = "patient_opted_out",
  ABANDONED = "abandoned",
  OTHER = "other",
}

export enum AppointmentOutcome {
  BOOKED = "booked",
  RESCHEDULED = "rescheduled",
  CANCELLED = "cancelled",
  NONE = "none",
}

/**
 * Close reasons that mean an appointment was booked (by Valerie or outside of it). Used to decide
 * when marking an SMS conversation COMPLETED should also flip the patient's SMS scheduling
 * engagement to booked. Excludes APPOINTMENT_BOOKED_BY_CLINIC, which is not offered as a manual
 * inbox close reason today.
 */
export function isAppointmentBookedCloseReason(reason: ClosedReason): boolean {
  return reason === ClosedReason.APPOINTMENT_BOOKED || reason === ClosedReason.APPOINTMENT_BOOKED_BY_VALERIE;
}

export enum AppointmentSchedulingStep {
  InitialMessage = "initial_message",
  Consent = "consent",
  CheckAvailability = "check",
  ChooseTime = "choose_time",
  ConfirmDetails = "confirm_details",
  ConfirmAppointment = "confirm",
}
